export default __webpack_public_path__ + "static/media/pivot3.b51a7eb5.png";